





































































































import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import ClearanceResponseCardHistory from "@/components/clearance/ClearanceResponseCardHistory.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { formatYearsMonthDay, simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Clearance, IClearance } from "@/models/clearance.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import { formatCurrency } from "@/lib/utility/currency-helper";

@Component({
  components: {
    LineItemsForm,
    ClearanceResponseCardHistory,
    ConfirmActionDialog
  },
  filters: { simpleDoubleDigitDate }
})
export default class ClearanceResponseCard extends mixins(PermissionMixin, RulesMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly getAutocompleteFilter = getAutocompleteFilter;

  readonly formatCurrency = formatCurrency;

  readonly CurrencyEnum = CurrencyEnum;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly statusIconMap = Clearance.statusIconMap;

  readonly statusColorMap = Clearance.statusColorMap;

  @Prop()
  value!: IClearance;

  @Prop()
  token!: string;

  isValid = false;
  loading = false;
  showConfirmDialog = false;

  dto = {
    status: RequestStatusEnum.REPLIED,
    repairStart: this.value?.repairStart,
    repairEnd: this.value?.repairEnd,

    get repairStartFormable(): string {
      if (!this.repairStart) {
        return "";
      }
      return formatYearsMonthDay(new Date(this.repairStart));
    },

    set repairStartFormable(date: string) {
      if (date) {
        this.repairStart = new Date(date).toISOString();
      } else {
        this.repairStart = undefined;
      }
    },

    get repairEndFormable(): string {
      if (!this.repairEnd) {
        return "";
      }
      return formatYearsMonthDay(new Date(this.repairEnd));
    },

    set repairEndFormable(date: string) {
      if (date) {
        this.repairEnd = new Date(date).toISOString();
      } else {
        this.repairEnd = undefined;
      }
    }
  };

  get endDateRules() {
    return [
      (value: string) => {
        if (!value || !this.dto?.repairStart) return true;

        const startDate = new Date(this.dto.repairStart);
        const endDate = new Date(value);

        return endDate >= startDate || this.$t("objects.clearance.repairEndValidation").toString();
      }
    ];
  }

  async confirmClearanceResponse() {
    this.loading = true;
    try {
      await this.value.respondAccept(this.token, {
        status: RequestStatusEnum.REPLIED,
        repairStart: this.dto.repairStart,
        repairEnd: this.dto.repairEnd
      });

      this.$toast.success(`${this.$t("clearance.response.success")} 👍`);
      this.showConfirmDialog = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
